"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgagePaymentRewardsType = exports.MortgagePaymentRewardsStatus = void 0;
var MortgagePaymentRewardsStatus;
(function (MortgagePaymentRewardsStatus) {
    MortgagePaymentRewardsStatus["INITIATED"] = "initiated";
    MortgagePaymentRewardsStatus["PAYMENT_SELECTED"] = "payment_selected";
    MortgagePaymentRewardsStatus["REWARDS_PREREQUISITE_IN_PROGRESS"] = "rewards_prerequisite_in_progress";
    MortgagePaymentRewardsStatus["REWARDS_PREREQUISITE_FULFILLED"] = "rewards_prerequisite_fulfilled";
    MortgagePaymentRewardsStatus["REWARDS_PREREQUISITE_EXPIRED"] = "rewards_prerequisite_expired";
    MortgagePaymentRewardsStatus["NO_VALID_PAYMENT_FOUND"] = "no_valid_payment_found";
    MortgagePaymentRewardsStatus["NO_RECURRING_STREAM_FOUND"] = "no_recurring_stream_found";
    MortgagePaymentRewardsStatus["CANCELED"] = "canceled";
})(MortgagePaymentRewardsStatus || (exports.MortgagePaymentRewardsStatus = MortgagePaymentRewardsStatus = {}));
var MortgagePaymentRewardsType;
(function (MortgagePaymentRewardsType) {
    MortgagePaymentRewardsType["cashBackV1"] = "cash_back_v1";
    MortgagePaymentRewardsType["cashBackV2"] = "cash_back_v2";
})(MortgagePaymentRewardsType || (exports.MortgagePaymentRewardsType = MortgagePaymentRewardsType = {}));
